// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".logo[data-v-1be579e7]{width:160px;height:40px;margin:auto;background-image:url(https://comoquiero.net/logo.svg);background-repeat:no-repeat;background-size:contain;background-position:50%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
